import {
  type PatientApplyProfileData,
  isNotEmptyOrSkippedOrNoneOrNotSureAnswer,
} from '@modules/patientApplyProfile/helpers/PatientApplyProfileData'
import { attributeIsPresentInPatientProfile } from './attributeIsPresentInPatientProfile'
import type { PatientTrialApplySurveyAttribute } from './types'

/**
 * If a question in the conditions/ section of apply flow should be shown to patient
 *
 * @param attribute Name of question step
 * @param patientProfileData Trial apply data for patient
 * @param showOnlyIfCurrentMedicationsAnswered Some questions are children of current medications question
 *
 * @returns if the question should be displayed
 */
export function shouldHideQuestionFromPatient({
  attribute,
  parentQuestionName,
  patientProfileData,
  validParentQuestionValues,
}: {
  attribute: PatientTrialApplySurveyAttribute
  parentQuestionName?: String
  patientProfileData: PatientApplyProfileData
  validParentQuestionValues?: string[]
}) {
  if (parentQuestionName) {
    const parentQuestionData = patientProfileData
      .filter((item) => item.conceptName === parentQuestionName)
      .map((entry) => entry.conceptValue)
      .filter(isNotEmptyOrSkippedOrNoneOrNotSureAnswer)

    if (parentQuestionData.length === 0) {
      return true
    }

    if (
      validParentQuestionValues &&
      !parentQuestionData.some((value) =>
        validParentQuestionValues
          .map((v) => v.toLowerCase())
          .includes(value.toLowerCase()),
      )
    ) {
      return true
    }
  }
  return attributeIsPresentInPatientProfile({
    attribute: attribute,
    patientProfileData,
    skippable: true,
  })
}
